/**
 * Store any objects that are used in a global scope but cannot be
 * categorized or grouped into its own module.
 */

export default {
  state() {
    return {
      modalOpen: false,
      datasetProjects: [],
    };
  },
  getters: {
    getModalOpen: (state) => state.modalOpen,
    getDatasetProjects: (state) => state.datasetProjects,
  },
  mutations: {
    SET_DATASET_PROJECTS(state, payload) {
      state['datasetProjects'] = payload;
    },
    SET_MODAL_OPEN(state, payload) {
      state['modalOpen'] = payload;
    },
    RESET_GLOBAL_MODULE(state) {
      state['datasetProjects'] = [];
      state['modalOpen'] = false;
    },
  },
  actions: {
    // Used to be used to pass around components but now moved to emits and props
    async setDatasetProjects({ commit }, datasetProjects) {
      await commit('SET_DATASET_PROJECTS', datasetProjects);
    },
    async setModalOpen({ commit }, payload) {
      await commit('SET_MODAL_OPEN', payload);
    },
    async resetGlobalModule({ commit }) {
      await commit('RESET_GLOBAL_MODULE');
    },
  },
};
